// @flow

import React from 'react'
import { connect } from 'react-redux'

import { pollEmbedUrl } from '../../urls'
import { selectCustomerById } from '../../stores/customersStore'

import CopyWithTooltip from './CopyWithTooltip'

import type { RootState, Customer, Poll } from '../../types'

export function generateEmbedScript(customer: Customer, poll: Poll) {
  if (customer && customer.embedCodeTemplate) {
    return customer.embedCodeTemplate
      .replace('[POLL_URL]', pollEmbedUrl(poll))
      .replace('[POLL_ID]', poll.name)
      .replace('[CUSTOMER_ID]', poll.customer)
  }
  return ''
}

function CopyEmbedScript({ customer, poll, children }) {
  return (
    <CopyWithTooltip
      text={generateEmbedScript(customer, poll)}
      labelBefore={'Copy embed script to clipboard'}
      labelAfter={'Embed script copied to clipboard'}
    >
      {children}
    </CopyWithTooltip>
  )
}

function mapStateToProps(state: RootState, ownProps) {
  return {
    poll: ownProps.poll,
    children: ownProps.children,
    customer: selectCustomerById(state, ownProps.poll.customer),
  }
}

export default connect(mapStateToProps)(CopyEmbedScript)



// WEBPACK FOOTER //
// ./src/components/polls/CopyEmbedScript.js